module.exports = __webpack_public_path__ + "img/203.d31c90c5.jpg";